import { v4 as uuid } from 'uuid'
import { minus, plus, times } from 'number-precision'
import { BET_RESULT } from 'constants/index'
import { calculateDiceOdds } from './utils/math.utils'

export const DEMO_DICE_GAME_SETTINGS = {
  id: '5',
  gameId: 5,
  minBet: {
    USD: 0.5,
    EUR: 0.5
  },
  maxBet: {
    USD: 20,
    EUR: 20
  },
  maxProfit: {
    USD: 1000,
    EUR: 1000
  },
  houseEdge: 1,
  minOdd: 1.01,
  maxOdd: 10000,
  minAutoRate: 1.01
}

export const diceGameDemoPlaceBet = function ({ number, rollOver, betAmount, demoBalance, currencyCode }) {
  try {
    const rangeInvalid = rollOver ? number < 2 || number > 98 : number < 2 || number > 98

    if (rangeInvalid) {
      throw new Error('InvalidDiceNumberErrorType')
    }
    const { minBet, maxBet, maxProfit, houseEdge, minOdd, maxOdd } = DEMO_DICE_GAME_SETTINGS

    if (betAmount < +minBet.amount || betAmount > +maxBet.amount) {
      throw new Error('InvalidDiceNumberErrorType')
    }

    const diceGameResult = Math.floor(Math.random() * 1e4) / 100

    let winningAmount = 0
    let betResult = BET_RESULT.LOST
    const probability = rollOver ? (100 - number) / 100 : (number / 100)

    if ((rollOver && +diceGameResult > number) || (!rollOver && +diceGameResult < number)) {
      const odds = calculateDiceOdds({ houseEdge, minOdd, maxOdd }, 1 / probability)

      betResult = BET_RESULT.WON
      winningAmount = times(betAmount, odds)

      const profit = minus(winningAmount, betAmount)

      if (profit > +maxProfit.amount) {
        winningAmount = plus(betAmount, maxProfit.amount)
      }
    }

    return {
      id: uuid(),
      number,
      winningNumber: diceGameResult,
      rollOver,
      betAmount,
      winningAmount,
      result: betResult
    }
  } catch (error) {
    throw new Error({ name: 'Internal', description: error.message })
  }
}
